<template>
  <div>
    <div class="mb-2">
      <TableImportErrorGlobal :columns="columns" v-if="hasErrors" :response-error="listErrors"/>
      <div v-else>
        <div>
          <p>Bước 1: Tải file mẫu</p>
          <div>
            <el-button class="btn btn-primary " size="small" @click="downloadFileExcelExample">
              <i class="el-icon-download text--white"></i>
              <span class="text--white">Tải xuống</span>
            </el-button>
          </div>
        </div>
        <div class="mt-6">
          <p>Bước 2: Tải file excel lên hệ thống</p>
          <div class="mb-2">
            <el-upload
                ref="upload"
                accept=".xlsx"
                :limit="1"
                list-type="text"
                action=""
                :file-list="fileList"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :auto-upload="false"
                :multiple="false"
            >
              <el-button class="btn btn-warning " size="small">
                <i class="el-icon-upload2 text--white"></i>
                <span class="text--white">Tải lên</span>
              </el-button>
            </el-upload>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <el-button @click="handleCancel">Hủy</el-button>
      <el-button :disabled="disableImport || disabledSubmit()" :loading="loading" type="success" class="btn btn-success"
                 @click="checkImport ? handleImportFileExcel() : handlePreviewImportFileExcel()">
        {{ checkImport ? 'Import ' : 'Kiểm tra data' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import TableImportErrorGlobal from "@/view/pages/classes/TableImportErrorGlobal.vue";
import { IMPORT_SUBSTITUTE, IMPORT_SUBSTITUTE_PREVIEW } from "@/core/services/store/course/classes.module";
import * as XLSX from "xlsx";
import moment from "moment-timezone";

export default {
  name: 'ImportClassTimeSheetSubstitute',
  components: { TableImportErrorGlobal },
  data() {
    return {
      loading: false,
      fileList: [],
      fileImport: null,
      disableImport: true,
      listErrors: [],
      checkImport: false,
      columns: {
        'ngay': 'Ngày',
        'ma_giao_vien': 'Mã giáo viên',
        'ten_lop': 'Tên lớp',
        'errors': 'Trạng thái'
      },
    }
  },
  computed: {
    hasErrors() {
      return this.listErrors && this.listErrors.length > 0;
    },
  },
  methods: {
    downloadFileExcelExample() {
      const filePath = process.env.BASE_URL + 'excel/File mẫu import công dạy thay.xlsx';
      const a = document.createElement('a');
      a.href = filePath;
      a.download = 'File mẫu import công dạy thay.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    cancelImport() {
      this.fileList = []
      this.fileImport = null;
      this.listErrors = [];
      this.startImport = true;
      this.checkImport = false;
      this.disableImport = true;
    },
    handleRemove() {
      this.fileList = []
      this.listErrors = [];
      this.checkImport = false;
      this.disableImport = true;
      this.startImport = true;
    },
    handleCancel() {
      if (this.hasErrors) {
        this.cancelImport();
      } else {
        this.closeDialog()
      }
    },
    async handlePreviewImportFileExcel() {
      this.disableImport = true;
      this.loading = true;
      if (!this.fileImport) {
        this.$notify({title: "Thất bại", message: "Chưa có file nào được chọn", type: "error"});
        this.disableImport = false;
        this.loading = false;
        return;
      }
      if (this.dataImport.length === 0) {
        this.$message.warning("Bạn không thể import khi file excel không có bản ghi nào");
        this.disableImport = false;
        this.loading = false;
        return;
      }
      try {
        const res = await this.$store.dispatch(IMPORT_SUBSTITUTE_PREVIEW, this.dataImport);
        const rawErrors = res?.data?.dataImport || [];
        this.checkImport = res.data?.checkImport;
        this.dataImport = rawErrors;
        this.isBack = true;
        this.loading = false;
        this.listErrors = rawErrors.map(item => ({
          ngay: item.ngay ? moment(item.ngay).format('DD-MM-YYYY') : null,
          ma_giao_vien: item.ma_giao_vien,
          ten_lop: item.ten_lop,
          errors: item.error || []
        }));
        if (this.listErrors?.length > 0) {
          this.$emit('errors', this.hasErrors)
        }
      } catch (error) {
        this.$message.error("Import thất bại");
      } finally {
        this.disabledSubmit()
        this.disableImport = false;
        this.loading = false;
      }
    },
    disabledSubmit() {
      return this.listErrors.filter(item => item.errors.length > 0).length > 0
    },
    async handleImportFileExcel() {
      this.loading = true;
      try {
        const res = await this.$store.dispatch(IMPORT_SUBSTITUTE, this.dataImport);
        if (!res.error) {
          this.$message.success("Import thành công");
        }
      } catch (e) {
        this.$message.error("Import thất bại");
      } finally {
        this.loading = false;
        this.$emit('closeDialog');
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList
      this.fileImport = file.raw;
      this.disableImport = false;
      this.parseExcel(this.fileImport);
    },
    parseExcel(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const workbook = XLSX.read(new Uint8Array(e.target.result), {type: "array"});
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const rawData = XLSX.utils.sheet_to_json(sheet, {header: 1, cellDates: true, raw: false});
        const formattedData = rawData.map(row =>
            row.map(cell => cell instanceof Date
                ? cell.toISOString().split('T')[0]  // yyyy-mm-dd
                : cell
            )
        );
        const [headers, ...rows] = formattedData;
        const columnMap = {
          "Ngày": "ngay",
          "Mã giáo viên": "ma_giao_vien",
          "Tên lớp": "ten_lop",
        };
        const mappedHeaders = headers.map(h => columnMap[h] || h);
        this.dataImport = rows
            .filter(row => row.length > 0)
            .map(row => {
              const item = {};
              mappedHeaders.forEach((key, i) => item[key] = row[i]);
              return {...item, error: []};
            });
      };
      reader.readAsArrayBuffer(file);
    },
  }
}
</script>

<style scoped>

</style>